

export function DNIaction(payload) {
    return {
      type: 'DNI',
      payload: payload,  
    };
  }

  export function CODEaction(payload) {
    return {
      type: 'CODE',
      payload: payload,  
    };
  }